<template>
	<div class="dealership">
		<div class="head-bold dealership__modal__title mb-2 flex gap-4">
			<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M46.1106 0H48.0006V0.94L44.1106 4.84C47.7284 8.90992 47.9793 14.9647 44.7106 19.32C44.1538 20.0628 44.2261 21.1016 44.8806 21.76C45.609 22.4932 45.609 23.6768 44.8806 24.41L23.5506 45.74C21.8646 47.4208 19.1366 47.4208 17.4506 45.74L2.2606 30.55C0.579798 28.864 0.579798 26.136 2.2606 24.45L23.5506 3.12C23.9015 2.76765 24.3783 2.56957 24.8756 2.56957C25.3729 2.56957 25.8497 2.76765 26.2006 3.12C26.8564 3.77756 27.8954 3.8542 28.6406 3.3C32.7977 0.154505 38.5565 0.220319 42.6406 3.46L46.1106 0ZM43.3806 23.12C42.0752 21.7457 41.9607 19.6269 43.1106 18.12C45.7654 14.5482 45.5782 9.61056 42.6606 6.25L39.0006 9.91C40.0492 11.3978 39.9422 13.4102 38.7417 14.7784C37.5412 16.1466 35.5597 16.5143 33.9482 15.668C32.3367 14.8217 31.5147 12.9817 31.9596 11.2168C32.4045 9.45178 34.0005 8.22129 35.8206 8.24C36.3955 8.24014 36.9629 8.37004 37.4806 8.62L41.2106 4.84C37.8549 2.31833 33.2363 2.31833 29.8806 4.84C29.2148 5.34943 28.3989 5.62374 27.5606 5.62C26.585 5.63701 25.6401 5.27909 24.9206 4.62L3.6806 25.86C2.77524 26.7659 2.77524 28.2341 3.6806 29.14L18.8606 44.32C19.7665 45.2254 21.2347 45.2254 22.1406 44.32L43.3806 23.12ZM37.7406 12.12C37.7406 13.1804 36.881 14.04 35.8206 14.04C34.7602 14.04 33.9006 13.1804 33.9006 12.12C33.9006 11.0596 34.7602 10.2 35.8206 10.2C36.3368 10.1999 36.8313 10.4077 37.1926 10.7764C37.5538 11.1452 37.7514 11.6439 37.7406 12.16V12.12ZM12.3825 29.9052L26.4256 15.8621L27.8398 17.2763L13.7967 31.3194L12.3825 29.9052ZM17.1951 34.7147L27.6249 24.2849L29.0391 25.6991L18.6093 36.1289L17.1951 34.7147Z"
					fill="#001E50"
				/>
			</svg>
			Selecione outra oferta para este produto:
		</div>

		<div v-if="!loading" class="dealership__list">
			<div data-label="$ Menor preço" class="dealership__item p-2" v-for="(d, $d) in dealerships" :key="$d" @click="selectDealership(d.id)" :class="{ selected: selectedDealership === d.id, featured: $d === 0 }">
				<!-- <div v-if="$d === 0" class="ribbon-menor-preco head-bold"><i class="fas fa-dollar-sign"></i> Menor preço</div> -->
				<div class="head-bold oferta__preco mb-2">{{ d.valor_item | formatarMoeda }}</div>
				<div class="oferta__conc mb-2">
					Vendido por: <span class="head-bold">{{ d.nome }}</span>
				</div>
				<div class="oferta__distancia flex gap-1">
					<img src="/custom/loja/assets/media/icons/localizacao-active.svg" alt="Localização" />
					<span>{{ distanceInKilometers(d.distancia) }} km</span>
				</div>
			</div>
		</div>
		<Loader v-else />
		<div class="p-4">
			<button class="btn__primary" :disabled="!selectedDealership" @click="changeDealer(selectedDealership)">Selecionar</button>
		</div>
	</div>
</template>

<script>
import DefaultButton from "@/components/Common/DefaultButton"
import Loader from "@/components/Common/Loader"
export default {
	components: {
		Loader,
		DefaultButton,
	},
	data() {
		return {
			selectedDealership: null,
		}
	},
	methods: {
		changeDealer(selectedDealer) {
			this.$emit("changeDealership", selectedDealer)
			window.scroll({
				top: 0,
				left: 0,
				behavior: "smooth",
			})
		},
		selectDealership(dsId) {
			this.selectedDealership = dsId
		},
		changeFilter(filter) {
			this.$emit("changeFilter", filter)
		},
		distanceInKilometers(distance) {
			return Math.round(distance)
		},
	},
	props: {
		dealerships: {
			type: Array,
			default: [],
		},
		activeDealership: {
			type: Number,
		},
		filter: {
			type: String,
			default: "menor_valor_do_item",
		},
		loading: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: "",
		},
		productName: {
			type: String,
			default: "",
		},
		images: {
			type: Object,
		},
	},
}
</script>

<style lang="scss" scoped>
.dealership {
	&__footer {
		display: flex;
		flex-direction: column;
		margin-top: 22px;
		button {
			height: 30px;
			font-size: 12px;
			line-height: 15px;
		}
	}
	&__card {
		-webkit-tap-highlight-color: transparent;
		height: auto;
		background: #ffffff;
		border: 2px solid #c2c2c2;
		border-radius: 10px;
		padding: 16px;
		&.selected {
			border: 2px solid var(--primary-color);
			&::after {
				box-shadow: 0px 4px 6px rgba(57, 133, 217, 0.4);
				content: "";
				display: block;
			}
		}
	}
	&__productname {
		height: 93px;
	}
	&__nav {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		height: 48px;
		box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
		border-radius: 5px;
		margin-bottom: 16px;
		&__btn {
			display: flex;
			flex-direction: column;
			padding: 9px 16px;
			font-size: 12px;
			line-height: 15px;
			svg.money {
				stroke: #c2cacf;
				path {
					fill: none;
				}
			}
			svg path {
				fill: #c2cacf;
			}
			&.active {
				box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
				svg.money {
					stroke: #001e50;
					path {
						fill: none;
						stroke: #001e50;
					}
				}
				svg path {
					fill: #001e50;
				}
				span {
					color: var(--text_dark_color);
				}
			}
		}
		&__btn:first-of-type.active {
			border-radius: 5px 0px 0px 5px;
		}
		&__btn:last-of-type.active {
			border-radius: 0px 5px 5px 0px;
		}
	}
	&__list {
		cursor: pointer;
		overflow-y: scroll;
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
		&::-webkit-scrollbar {
			display: none;
		}

		&__item {
			padding: 8px;
			&:hover {
				border: 2px solid #00b0f0;
			}
			&.selected {
				border: 2px solid #00b0f0;
			}
		}
		&__prices {
			margin-top: 8px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			&__total {
				padding: 4px;
			}
		}
		&__info {
			display: grid;
			grid-template-columns: 2fr 1fr;
			// max-width: 210px;
			&__distance {
				margin-right: 16px;
				padding: 4px;
			}
			&__days {
				padding: 4px;
			}
		}
	}
}
@media (min-width: 768px) {
	.dealership {
		&__footer {
			flex-direction: row;
			justify-content: space-between;
		}
		&__frete {
			width: 126px;
			padding: 4px;
			background-color: #f3f4f5;
			margin-bottom: 5px;
		}
		&__total {
			width: 126px;
			padding: 6px 4px;
			background-color: #f3f4f5;
		}
		&__right {
			width: 100%;
		}
		&__left {
			max-width: 240px;
			img {
				border: 1px solid #dfe4e8;
			}
		}
		&__card {
			background: #ffffff;
			box-shadow: 0px 4px 6px rgba(154, 155, 155, 0.4);
			border-radius: 10px;
			padding: 16px;
			&.selected {
				&::after {
					box-shadow: 0px 4px 6px rgba(57, 133, 217, 0.4);
					content: "";
					display: block;
				}
			}
		}
		&__list {
			height: 231px;
			overflow-y: scroll;
			&__item {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 32px;
				padding: 8px 16px;
				align-items: center;
			}
			&__prices {
				margin-top: 0;
				display: flex;
				justify-content: space-between;
				&__total {
					width: 122px;
					padding: 5.5px 8px;
					margin-right: 21.5px;
				}
			}
			&__info {
				display: flex;
				flex-wrap: wrap;
				margin-right: 10px;
				&__name {
					order: 1;
					display: flex;
					width: 100%;
					align-items: flex-start;
				}
				&__distance {
					width: 87px;
					display: flex;
					order: 2;
					margin-right: 16px;
					padding: 4px;
				}
				&__days {
					display: flex;
					order: 3;
					padding: 4px;
				}
			}
		}
		&__nav {
			height: 64px;
			grid-template-columns: 1fr 1fr 1fr;
			&__btn {
				flex-direction: row;
				justify-content: center;
				align-items: center;
				svg {
					height: 24px;
					width: 24px;
					margin-right: 8px;
					margin-bottom: 0;
				}
				svg.money {
					width: 12px !important;
				}
			}
		}
	}
}

.dealership {
	&__lr {
		margin-bottom: 16px;
	}
	&__list {
		height: 180px;
	}
	&__nav {
		// gap: 8px;
		// font-size: 12px;
		// line-height: 15px;
		&__btn {
			flex-direction: row;
			align-items: center;
		}
	}
	&__modal {
		&__title {
			font-size: 20px;
			line-height: 24px;
			font-weight: bold;
			padding: 16px;
			padding-bottom: 0;
			color: var(--text_dark_color);
		}
		&__subtitle {
			font-size: 12px;
			line-height: 15px;
			color: var(--text_color);
			text-align: center;
			margin-bottom: 4px;
		}
	}
	&__card {
		padding: 12px;
		margin-bottom: 12px;
		&__name {
			color: var(--text_color);
			margin-bottom: 8px;
			font-size: 12px;
			line-height: 15px;
		}
		&__total {
			background-color: var(--background_light_color);
			color: var(--text_color);
			padding: 6px;
			text-align: center;
			font-size: 12px;
			line-height: 15px;
		}
		&__infos {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 4px;
			text-align: center;
			margin-bottom: 4px;
			font-size: 12px;
			line-height: 15px;
			&__distance {
				display: flex;
				align-items: center;
				justify-content: center;
				height: 23px;
				background-color: var(--background_light_color);
				color: var(--text_color);
			}
			&__price {
				background-color: var(--background_light_color);
				color: var(--text_color);
				line-height: 15px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				display: flex;
				align-items: center;
				height: 36px;
			}
			&__frete {
				background-color: var(--background_light_color);
				color: var(--text_color);
				display: flex;
				align-items: center;
				justify-content: center;
				height: 23px;
			}
			&__freteprice {
				background-color: var(--background_light_color);
				color: var(--text_color);
				justify-content: center;
				display: flex;
				flex-direction: column;
				align-items: center;
				height: 36px;
			}
		}
		&.selected {
			.dealership__card__name {
				color: var(--text_dark_color);
			}
			.dealership__card__infos__distance {
				&.bg-blue600 {
					background-color: var(--primary_color);
					color: #fff;
				}
			}
			.dealership__card__infos__frete {
				&.blue600 {
					background-color: var(--primary_color);
					color: #fff;
				}
			}
			.dealership__card__infos__price {
				&.bg-blue600 {
					background-color: var(--primary_color);
					color: #fff;
				}
			}
			.dealership__card__total {
				background-color: var(--primary_color);
				color: #fff;
			}
		}
	}
	&__footer {
		&__text {
			font-size: 10px;
			line-height: 12px;
			margin-top: 8px;
		}
	}
}

/** Media exclusiva para o modal */
@media (min-width: 480px) {
	/* width */
	::-webkit-scrollbar {
		height: 4px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: #ffffff;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #c2c2c2;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
	.dealership {
		&__listwrapper {
			overflow: auto;
			height: 154px;
			margin-bottom: 8px;
		}
		.glide__slides {
			padding: 8px 0;
			.dealership__card {
				height: 142px;
				flex-direction: column;
				margin-right: 8px;
				margin-bottom: 0;
			}
			.dealership__card:last-of-type {
				margin-right: 0;
			}
		}
		&__list {
			width: 100vw;
			flex-direction: row;
			height: 138px;
			padding: 0;
		}
		&__nav {
			&__btn {
				flex-direction: row;
				align-items: center;
				svg {
					margin-right: 4px;
				}
			}
		}
		&__modal {
			&__title {
				font-size: 20px;
				line-height: 24px;
				margin-bottom: 16px;
			}
			&__subtitle {
				font-size: 16px;
				line-height: 19px;
				margin-bottom: 8px;
			}
		}
		&__card {
			padding: 12px;
			margin-bottom: 16px;
			height: 56px;
			display: flex;
			align-items: center;
			&__name {
				margin-bottom: 8px;
			}
			&__total {
				background-color: var(--background_light_color);
				color: var(--text_color);
				padding: 6px;
				text-align: center;
				font-size: 12px;
				line-height: 15px;
				width: 100%;
			}
			&__infos {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 4px;
				text-align: center;
				margin-bottom: 4px;
				font-size: 12px;
				line-height: 15px;
				width: 100%;
				&__distance {
					display: flex;
					align-items: center;
					justify-content: center;
					height: 23px;
				}
				&__price {
					line-height: 15px;
					display: flex;
					flex-direction: column;
					justify-content: center;
					display: flex;
					align-items: center;
					height: 36px;
				}
				&__frete {
					display: flex;
					align-items: center;
					justify-content: center;
					height: 23px;
				}
				&__freteprice {
					justify-content: center;
					display: flex;
					flex-direction: column;
					align-items: center;
					height: 36px;
				}
			}
		}
		&__footer {
			display: grid;
			grid-template-columns: 268px 1fr;
			gap: 27px;
			align-items: center;
			&__text {
				font-size: 12px;
				line-height: 15px;
			}
			button {
				order: 2;
			}
		}
	}
}
@media (min-height: 900px) {
	.dealership {
		&__listwrapper {
			overflow: auto;
			height: 154px;
			margin-bottom: 8px;
		}
		.glide__slides {
			padding: 0;
			margin-bottom: 16px;
			.dealership__card {
				height: 200px;
				flex-direction: column;
				margin-right: 8px;
				margin-bottom: 0;
			}
			.dealership__card:last-of-type {
				margin-right: 0;
			}
		}
		&__list {
			width: 100vw;
			flex-direction: row;
			height: 138px;
			padding: 0;
		}
		&__nav {
			&__btn {
				flex-direction: row;
				align-items: center;
				font-size: 16px;
				line-height: 19px;
				svg {
					margin-right: 9px;
					height: 24px !important;
					width: 24px !important;
				}
			}
		}
		&__modal {
			&__title {
				// font-size: 24px;
				// line-height: 29px;
				// margin-bottom: 28px;
			}
			&__subtitle {
				font-size: 20px;
				line-height: 24px;
				margin-bottom: 24px;
			}
		}
		&__card {
			padding: 16px;
			margin-bottom: 16px;
			height: 56px;
			display: flex;
			align-items: center;
			&__name {
				font-size: 16px;
				line-height: 19px;
			}
			&__total {
				padding: 8px;
				font-size: 16px;
				line-height: 19px;
				height: 35px;
			}
			&__infos {
				gap: 8px;
				margin-bottom: 8px;
				font-size: 16px;
				line-height: 19px;
				&__distance {
					height: 35px;
				}
				&__frete {
					height: 35px;
				}
				&__price {
					height: 54px;
					line-height: 19px;
				}
				&__freteprice {
					justify-content: center;
					display: flex;
					flex-direction: column;
					align-items: center;
					height: 54px;
				}
			}
		}
		&__footer {
			display: grid;
			grid-template-columns: 429px 1fr;
			gap: 24px;
			align-items: center;
			margin-top: 36px;
			&__text {
				font-size: 16px;
				line-height: 19px;
			}
			button {
				order: 2;
				height: 56px;
				max-width: 149px;
				font-size: 20px;
				line-height: 24px;
			}
		}
	}
}
.glide__bullets {
	bottom: -12px;
}
.glide__bullet {
	// border: 1px solid #c2cacf;
	background-color: #c2c2c2;
}
.glide__bullet--active {
	background-color: #535353;
}
.dealership {
	overflow: hidden;
}
.dealership__list {
	height: 406px;
	overflow-y: scroll;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr;
	gap: 8px;
	grid-template-rows: 88px;
	grid-auto-rows: 88px;
}
.dealership__item {
	// border: 1px solid #c2cacf;
	// border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	background: #fff;
	margin: 0 16px;
	position: relative;
	&.selected {
		border: 2px solid #001e50;
	}
}
.dealership__item.featured::before {
	position: absolute;
	top: 6px;
	right: -8px;
	content: "";
	background: #003000;
	height: 28px;
	width: 28px;
	transform: rotate(45deg);
	z-index: -1;
}

.dealership__item.featured::after {
	position: absolute;
	content: attr(data-label);
	top: -2px;
	right: -14px;
	padding: 2px;
	width: 115px;
	background: #029640;
	color: white;
	text-align: center;
	font-size: 12px;
	box-shadow: 4px 4px 15px rgba(26, 35, 126, 0.2);
}
.oferta__preco {
	font-size: 18px;
	line-height: 1;
	color: var(--text_dark_color);
}
.oferta__conc {
	font-size: 12px;
	color: #6a767d;
	line-height: 1;
	span {
		color: var(--btn-primary-bg-color);
	}
}
.oferta__distancia {
	font-size: 14px;
	line-height: 19px;
	span {
		color: #6a767d;
	}
}
.ribbon-menor-preco {
	position: absolute;
	right: 4px;
	top: 4px;
	background-color: green;
	padding: 4px;
	color: #fff;
	font-size: 12px;
}
</style>
